// extracted by mini-css-extract-plugin
export default {"logoStrip":"styles-module--logoStrip--c4e22","logoItem":"styles-module--logoItem--e942e"};